import { Icon, IconName } from "@/components/Icon";
import styles from "./index.module.scss";
import { useMemo, Fragment } from "react";
type Props = {
  step: number;
  steps: any
};
export const CentifySteps = ({ step, steps }: Props) => {
  const lastStep = useMemo(() => {
    return steps[steps.length - 1].step;
  }, [steps])
  return (
    <section className={styles.steps}>
      {
        steps.map((stepItem: any) => {
          return <Fragment key={stepItem.step}>
            <div>
          <Icon name={`${stepItem.icon}${step >= stepItem.step ? "-active" : ""}` as IconName} size={"24px"} />
            <div className={styles.step_text}>{stepItem.text}</div>
            

        </div>
        {
          stepItem.step !== lastStep ? (
            <div>
              <Icon name={"operate_arrow_right"} size={"24px"} />
            </div>
          ) : null
        }

          </Fragment>
        })
      }
    </section>
  );
};
